import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PackageViewComponent } from './package-view/package-view.component';
import { PackageFormComponent } from './package-form/package-form.component';
import { PackageRoutingModule } from './package-routing-module';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/material.module';




@NgModule({
  declarations: [
    PackageViewComponent,
    PackageFormComponent
  ],
  imports: [
    CommonModule,
    PackageRoutingModule,
    AngularMaterialModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class PackageModule { }
